module.exports = __webpack_public_path__ + "assets/8a3df98757ad37478082fdf0468437d6.mp3";